// Per-app colours for coach / guide pages (same layout everywhere, tone matches the app the coach lives in).
const T = {
  golf: ["#0b1a16", "23,50,42"],
  atelier: ["#0b0a08", "52,42,26"],
  networker: ["#120c06", "64,42,18"],
  gym: ["#0d0b0a", "58,34,18"],
  inner_path: ["#0b1426", "24,39,66"],
  foundations: ["#0c1a33", "30,52,94"],
  lights: ["#170e06", "62,38,16"],
  soulumo: ["#0a132a", "27,42,78"],
};
const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(",");

export const coachTheme = (area) => {
  const [bg, glow] = T[area] || T.golf;
  return {
    bg,
    glow: `rgb(${glow})`,
    card: `linear-gradient(135deg, rgba(${glow},0.9), rgba(${rgb(bg)},0.95))`,
    cardGold: `linear-gradient(135deg, rgba(215,187,122,0.17), rgba(${glow},0.9))`,
    deep: (a) => `rgba(${rgb(bg)},${a})`,
  };
};

// CSS variables so shared pieces (C.bg etc.) pick up the page's app colours.
export const coachThemeVars = (area) => {
  const t = coachTheme(area);
  return { "--coach-bg": t.bg, "--coach-glow": t.glow, "--coach-card": t.card, "--coach-card-gold": t.cardGold, "--coach-deep": t.deep(0.92) };
};

// While a coach page is open, put its app colours on <html> so overlays and the page body match.
export const useCoachTheme = (area, useEffect) => useEffect(() => {
  const root = document.documentElement.style;
  const vars = coachThemeVars(area);
  Object.entries(vars).forEach(([k, v]) => root.setProperty(k, v));
  const bg = document.body.style.background;
  const htmlBg = root.background;
  document.body.style.background = vars["--coach-bg"];
  root.background = vars["--coach-bg"]; // html too: other themes may clear body, and iOS overscroll shows html
  return () => { Object.keys(vars).forEach((k) => root.removeProperty(k)); document.body.style.background = bg; root.background = htmlBg; };
}, [area]);

export const areaFromPath = (path = "") => {
  const p = path.split("?")[0].split("/")[1] || "";
  return { "inner-path": "inner_path", "one-million-lights": "lights" }[p] || p;
};
